import React from "react";
import { BsGearWideConnected } from "react-icons/bs";

function SettingButton({ onclick }) {
  return (
    <button
      type="button"
      className="inline-flex items-center mr-3 text-sm font-medium text-gray-400 duration-300 ease-in-out shadow-sm hover:text-gray-600 focus:outline-none"
      onClick={onclick}
    >
      <BsGearWideConnected className="w-4 h-4" />
    </button>
  );
}

export default SettingButton;
